<template>
  <div class="dicom-page">
    <div class="dicom-card">
      <h1 class="dicom-title">{{ $t("nav.dicom_anonymize_download") }}</h1>
      <a class="download-button" :href="downloadUrl" download target="_blank">
        {{ $t("nav.dicom_anonymize_download") }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "DicomAnonymizeDownload",
  data() {
    return {
      downloadUrl: "",
    };
  },
  computed: {
    ...mapState({
      license_request: (state) => state.license_request,
      backendConfig: (state) => state.backendConfig,
    }),
  },
  mounted() {
    document.title = this.$t("nav.dicom_anonymize_download");

    this.downloadUrl =
      this.backendConfig.backend_url + "ossfs/DicomAnonymousSetupV1Release.zip";
  },
};
</script>

<style scoped>
.dicom-page {
  min-height: calc(100vh - 130px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
}

.dicom-card {
  width: 100%;
  max-width: 720px;
  text-align: center;
}

.dicom-title {
  margin: 0 0 32px;
  font-size: 42px;
  font-weight: 700;
  line-height: 1.3;
  color: #212528;
}

.download-button {
  display: inline-block;
  min-width: 180px;
  padding: 12px 28px;
  border-radius: 8px;
  background: #0d6efd;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.2s ease;
}

.download-button:hover {
  background: #0b5ed7;
}
</style>
